'use client';
import { Archive, Home02, Plus } from '@ethsign/icons';
import { useToast } from '@ethsign/ui';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { ColorRemoveIcon, ConfirmModal, MenuItem } from '@/components';
import { usePathname, useRouter } from '@/hooks';

import { createFolders, deleteFolders, updateFolders } from '@/services';

import { FolderItem as IFolderItem } from '@/types';

import { FolderItem } from './FolderItem';

interface Props {
  folders?: { rows: readonly IFolderItem[]; totalContract?: number };
  folderId?: string;
  vm: any;
}
export function SideNavigation(props: Props) {
  const { folders, vm, folderId } = props;
  const { toast } = useToast();
  const pathname = usePathname() as string;
  const router = useRouter();
  const [currentFolder, setCurrentFolder] = useState<any>({ id: Number(folderId) || 'all' });
  const [tempFolder, setTempFolder] = useState<any>(folders?.rows || []);
  const [modalInfo, setModalInfo] = useState({ open: false, id: 0, folderName: '' });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setTempFolder(folders?.rows);
  }, [folders?.rows]);
  const isAllActive = pathname === '/dashboard' && currentFolder.id === 'all';
  return (
    <div className="relative min-w-[250px] w-[250px] bg-white h-full px-2 py-8 flex flex-col justify-between border-r border-gray-200">
      <div className=" flex flex-col flex-1 overflow-y-hidden">
        <div
          onClick={() => {
            router.push('/dashboard');

            setCurrentFolder({ id: 'all' });
          }}
        >
          <MenuItem
            icon={<Home02 size={16} color="#344054"></Home02>}
            isActive={isAllActive}
            rightIcon={
              <Plus
                color="#344054"
                size={16}
                onClick={(e: any) => {
                  e.stopPropagation();
                  if (tempFolder.length === folders?.rows?.length) {
                    setTempFolder([
                      ...tempFolder,
                      { id: 'temp', folderName: 'Folder ' + ((folders?.rows?.length || 0) + 1) }
                    ]);
                  }
                }}
              ></Plus>
            }
          >
            <span>
              All Contracts{' '}
              {folders?.totalContract ? (
                <span
                  title={folders.totalContract + ''}
                  className={`text-gray-500 rounded-sm p-1 ml-2 bg-primary-${isAllActive ? '100' : '50'} `}
                >
                  {folders?.totalContract > 99999 ? '99,999+' : folders?.totalContract}
                </span>
              ) : (
                ''
              )}
            </span>
          </MenuItem>
        </div>
        <div className="overflow-y-auto flex-1 ">
          {tempFolder?.map(({ id, folderName, contractCount }: any) => (
            <FolderItem
              count={contractCount}
              key={id}
              id={id}
              onClick={() => {
                if (id !== 'temp') {
                  router.push(`/dashboard?folderId=${id}`);

                  setCurrentFolder({ folderName, id });
                }
              }}
              isEditing={id === 'temp'}
              isActive={currentFolder.id === id}
              name={folderName}
              onEdit={({ name, id }: any) => {
                if (id !== 'temp') {
                  updateFolders({ id, folderName: name }).then(() => {
                    vm.getFolders();
                  });
                } else {
                  createFolders({ folderName: name })
                    .then(() => {
                      vm.getFolders();
                    })
                    .catch(() => {
                      setLoading(false);
                    });
                }
              }}
              onDelete={() => {
                setModalInfo({ open: true, id, folderName });
              }}
            ></FolderItem>
          ))}
        </div>
      </div>
      <div className="absolute bottom-[32px] left-0 w-full pl-[8px]">
        <Link to="/dashboard/hidden-contracts">
          <MenuItem
            icon={<Archive size={16} color="#344054"></Archive>}
            isActive={pathname?.indexOf('hidden-contracts') > 0}
          >
            Trash
          </MenuItem>
        </Link>
      </div>
      <ConfirmModal
        loading={loading}
        icon={<ColorRemoveIcon></ColorRemoveIcon>}
        type="warn"
        open={modalInfo.open}
        title="Delete Folder"
        content={`Are you sure you want to delete ${modalInfo.folderName}? All contracts within will be hidden. This action can not be undone.`}
        confirmText="Delete"
        onConfirm={() => {
          if (!loading) {
            setLoading(true);
            deleteFolders({ id: modalInfo.id })
              .then(() => {
                setLoading(false);
                vm.getFolders();
                if (Number(folderId) === modalInfo.id) {
                  router.push('/dashboard');
                  setCurrentFolder({ id: 'all' });
                }
                toast({
                  variant: 'success',
                  title: 'Success',
                  description: `${modalInfo.folderName} has been deleted`
                });
                setModalInfo({ ...modalInfo, open: false });
              })
              .catch(() => {
                setLoading(false);
              });
          }
        }}
        onOpenChange={(open) => {
          setModalInfo({ ...modalInfo, open });
        }}
      ></ConfirmModal>
    </div>
  );
}
